var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5C1 7.95419 7.95419 1 16.5 1C25.0458 1 32 7.95419 32 16.5C32 25.0458 25.0458 32 16.5 32C7.95419 32 1 25.0458 1 16.5Z",
    stroke: "#8799C5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.22367V16.4998H27.7761C27.7798 15.0179 27.4907 13.55 26.9253 12.1802C26.3599 10.8105 25.5295 9.56593 24.4817 8.51811C23.4338 7.47029 22.1893 6.63984 20.8196 6.07447C19.4498 5.50911 17.9818 5.21997 16.5 5.22367Z",
    fill: "#8799C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.1d622b275cff90f56a190cf45b0c4874.svg";
export { ForwardRef as ReactComponent };